module.exports = __webpack_public_path__ + "assets/gonglve.61a10752.svg";